export function init() {
    if (typeof threeColSearchFieldTarget === 'undefined') {
        return false;
    }

    const searchForm = document.querySelector('.module-3colsearch form');
    const targetSection = document.getElementById(threeColSearchFieldTarget);

    if (threeColSearchFieldTarget && searchForm && targetSection) {
        const items = targetSection.querySelectorAll('.col .content ul li');

        const itemsTexts = [];
        items.forEach((item, index) => {
            itemsTexts.push(item.textContent.toLowerCase());
        });

        function filter(searchTerm='') {
            searchTerm = searchTerm.toLowerCase();

            itemsTexts.forEach((itemText='', index) => {
                items[index].hidden = ! (itemText.includes && itemText.includes((searchTerm)));
            });
        }

        function showAll() {
            items.forEach((item) => item.hidden=false);
        }

        searchForm.addEventListener('submit', function(event) {
            event.preventDefault();
            const formData = new FormData(this);
            const searchTerm = formData.get('q').trim();

            if (searchTerm === '') {
                showAll();
            }
            else {
                filter(searchTerm);
            }
        })
    }
}
